import BreadcrumbsBuilder from '~/helpers/BreadcrumbsBuilder';

export default class BreadcrumbsDispatcher {
  public static EVENT_TYPE: string = 'breadcrumbsSet';

  public static dispatchItems(breadcrumbsBuilder: BreadcrumbsBuilder) {
    const event = new CustomEvent(this.EVENT_TYPE, { detail: breadcrumbsBuilder.getItems() });
    window.dispatchEvent(event);
  }
}
